if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cartNotification = document.querySelector('cart-notification');
    }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


$(document).ready(function () {
  // Create our number formatter.
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  $('.js-quantity-select').on('change', function () {
    var selectedQuantity = parseFloat($(this).val());
    var variantPrice = parseFloat($('.js-price').data('raw-price'));
    var variantPriceTimesQuantity = selectedQuantity * variantPrice;

    $('.js-price').html('$' + variantPriceTimesQuantity);
  });


  const breakpoint = window.matchMedia( '(min-width: 750px)' );

  let pdpMainSwiper;
  const breakpointChecker = function() {
    if ( breakpoint.matches === true ) {
	  if ( pdpMainSwiper !== undefined ) pdpMainSwiper.destroy( true, true );
	  return;
      } else if ( breakpoint.matches === false ) {
        return enableSwiper();
      }
  };


  const enableSwiper = function() {
    const pdpMainSwiper = new Swiper ('.swiper-main-product', {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      grabCursor: true,
      freeMode: false,
      loop: false,
      spaceBetween: 0,
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  };


  breakpoint.addListener(breakpointChecker);

  breakpointChecker();



  $('.product-selector__trigger').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.product-selector').toggleClass('product-selector--open');
    $('body').on('click.closeFlavorDropdown', function (e) {
      if ($(e.target).closest('.product-selector__trigger').length == 0) {
        $('.product-selector').removeClass('product-selector--open');
        $('body').off('click.closeFlavorDropdown');
      }
    });
  });

});
